<template>
  <div class="modern-registration-wrapper">
    <div v-if="!loading" class="registration-page">
      <div class="container">
        <div class="row registration-wrapper">
          <div class="col-lg-7 col-md-9 col-12 mx-auto">
            <div class="registration-card checkout-form-1">
              <!-- Header -->
              <div class="registration-header">
                <img
                  src="../../../theme-assets/images/logo/culogo-h.png"
                  class="logo-img"
                  alt="University Logo"
                />
              </div>

              <!-- Step Indicator -->
              <div class="step-indicator-wrapper">
                <div class="step-indicator">
                  <div class="step" :class="{ active: step >= 1, completed: step > 1 }">
                    <span class="step-number">1</span>
                    <span class="step-label">Information</span>
                  </div>
                  <div class="step-line" :class="{ active: step > 1 }"></div>
                  <div class="step" :class="{ active: step >= 2, completed: step > 2 }">
                    <span class="step-number">2</span>
                    <span class="step-label">Confirmation</span>
                  </div>
                  <div class="step-line" :class="{ active: step > 2 }"></div>
                  <div class="step" :class="{ active: step >= 3 }">
                    <span class="step-number">3</span>
                    <span class="step-label">Complete</span>
                  </div>
                </div>
              </div>

              <!-- Step 1: Information Form -->
              <div v-if="step === 1" class="registration-form">
                <h5 class="my-3 text-center">GCE Equivalence Registration</h5>
                <b-form @submit.prevent="goToConfirmation">
                  <!-- Passport or Birth Registration -->
                  <div class="form-group-modern">
                    <label class="input-label">
                      Passport / Birth Registration / NID 
                      <span class="text-danger">*</span>
                    </label>
                    <b-form-select
                      v-model="formData.documentType"
                      :options="documentOptions"
                      class="modern-select"
                      required
                    ></b-form-select>
                  </div>

                  <!-- Document Number -->
                  <div class="form-group-modern" v-if="formData.documentType === 'Passport' || formData.documentType === 'BirthRegistration' || formData.documentType === 'NID' ">
                    <label class="input-label">
                      {{ formData.documentType === 'Passport'
                        ? 'Passport Number' :
                         formData.documentType === 'BirthRegistration' ?
                        'Birth Registration Number'  :
                        'NID'}}
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-wrapper">
                      <i class="fa fa-id-card input-icon"></i>
                      <b-form-input
                        v-model="formData.documentNumber"
                        type="text"
                        class="modern-input"
                        :placeholder="formData.documentType === 'Passport'
                        ? 'Passport Number' :
                         formData.documentType === 'BirthRegistration' ?
                        'Birth Registration Number'  :
                        'NID Number'"
                        minlength="5"
                        maxlength="20"
                        required
                      ></b-form-input>
                    </div>
                  </div>

                  <!-- Email Address -->
                  <div class="form-group-modern">
                    <label class="input-label">Email Address</label>
                    <div class="input-wrapper">
                      <i class="fa fa-envelope input-icon"></i>
                      <b-form-input
                        v-model="formData.email"
                        type="email"
                        class="modern-input"
                        placeholder="Enter your email address"
                        maxlength="100"
                      ></b-form-input>
                    </div>
                  </div>

                  <!-- Mobile Number -->
                  <div class="form-group-modern">
                    <label class="input-label">Mobile Number (Do not include +88)</label>
                    <div class="input-wrapper">
                      <i class="fa fa-mobile input-icon"></i>
                      <b-form-input
                        v-model="formData.mobile"
                        type="number"
                        class="modern-input"
                        placeholder="Enter your mobile number"
                        minlength="11"
                        maxlength="15"
                      ></b-form-input>
                    </div>
                  </div>

                  <!-- HSC Type -->
                  <div class="form-group-modern">
                    <label class="input-label">
                      HSC / Higher Secondary Standard Type 
                      <span class="text-danger">*</span>
                    </label>
                    <b-form-select
                      v-model="formData.hscType"
                      :options="hscOptions"
                      class="modern-select"
                      required
                    ></b-form-select>
                  </div>

                  <!-- SSC Type -->
                  <div class="form-group-modern">
                    <label class="input-label">
                      SSC / Secondary Standard Type 
                      <span class="text-danger">*</span>
                    </label>
                    <b-form-select
                      v-model="formData.sscType"
                      :options="sscOptions"
                      class="modern-select"
                      required
                    ></b-form-select>
                  </div>

                  <b-button
                    v-if="!isButtonLoading"
                    type="submit"
                    class="registration-button mt-4"
                    block
                  >
                    <i class="fa fa-arrow-right"></i> Next
                  </b-button>
                  <b-button
                    v-else
                    class="registration-button loading mt-4"
                    block
                    disabled
                  >
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                  </b-button>
                </b-form>
              </div>

              <!-- Step 2: Confirmation -->
              <div v-else-if="step === 2" class="registration-form">
                <h5 class="my-3 text-center">Confirm Your Details</h5>
                
                <b-form @submit.prevent="submitRegistration">
                  <!-- Retype Email -->
                  <div v-if="formData.email" class="form-group-modern">
                    <label class="input-label">
                      Confirm Email Address
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-wrapper">
                      <i class="fa fa-envelope input-icon"></i>
                      <b-form-input
                        v-model="confirmData.email"
                        type="email"
                        class="modern-input"
                        placeholder="Re-enter your email address"
                        required
                      ></b-form-input>
                    </div>
                    <small v-if="confirmData.email && confirmData.email !== formData.email" class="text-danger d-block mt-1">
                      <i class="fa fa-exclamation-circle"></i> Email does not match
                    </small>
                  </div>

                  <!-- Retype Mobile -->
                  <div v-if="formData.mobile" class="form-group-modern">
                    <label class="input-label">
                      Confirm Mobile Number
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-wrapper">
                      <i class="fa fa-mobile input-icon"></i>
                      <b-form-input
                        v-model="confirmData.mobile"
                        type="text"
                        class="modern-input"
                        placeholder="Re-enter your mobile number"
                        required
                      ></b-form-input>
                    </div>
                    <small v-if="confirmData.mobile && confirmData.mobile !== formData.mobile" class="text-danger d-block mt-1">
                      <i class="fa fa-exclamation-circle"></i> Mobile number does not match
                    </small>
                  </div>

                  <!-- Delivery Method -->
                  <div class="form-group-modern mt-4">
                    <label class="input-label mb-2">
                      Where would you like to receive your credentials?
                      <span class="text-danger">*</span>
                    </label>
                    <b-form-radio-group v-model="deliveryMethod" class="delivery-options" required>
                      <div v-if="formData.email" class="delivery-radio-wrapper mb-2 py-3 px-2">
                        <b-form-radio value="email" class="delivery-radio">
                          <span class="radio-content">
                            <i class="fa fa-envelope"></i>
                            <span>Email Only</span>
                          </span>
                        </b-form-radio>
                      </div>
                      <div v-if="formData.mobile" class="delivery-radio-wrapper mb-2 py-3 px-2">
                        <b-form-radio value="mobile" class="delivery-radio">
                          <span class="radio-content">
                            <i class="fa fa-mobile"></i>
                            <span>Mobile Only</span>
                          </span>
                        </b-form-radio>
                      </div>
                      <div v-if="formData.email && formData.mobile" class="delivery-radio-wrapper mb-2 py-3 px-2">
                        <b-form-radio value="both" class="delivery-radio">
                          <span class="radio-content">
                            <i class="fa fa-paper-plane"></i>
                            <span>Both Email & Mobile</span>
                          </span>
                        </b-form-radio>
                      </div>
                    </b-form-radio-group>
                  </div>

                  <b-button
                    v-if="!isButtonLoading"
                    type="submit"
                    class="registration-button mt-4"
                    block
                    :disabled="!isConfirmationValid"
                  >
                    <i class="fa fa-check-circle"></i> Submit Registration
                  </b-button>
                  <b-button
                    v-else
                    class="registration-button loading mt-4"
                    block
                    disabled
                  >
                    <i class="fa fa-spinner fa-spin"></i> Submitting...
                  </b-button>

                  <b-button
                    type="button"
                    variant="outline-secondary"
                    class="registration-back-button mt-3"
                    @click="goBackToStep1"
                    block
                    :disabled="isButtonLoading"
                  >
                    <i class="fa fa-arrow-left"></i> Go Back
                  </b-button>
                </b-form>
              </div>

              <!-- Step 3: Success -->
              <div v-else-if="step === 3" class="registration-form text-center">
                <div class="success-icon mb-3">
                  <i class="fa fa-check-circle"></i>
                </div>
                <h5 class="mb-3">Registration Successful!</h5>
                <div class="registration-message">
                  <p class="mb-3">
                    Your application has been submitted successfully.
                  </p>
                  <div class="credential-info">
                    <p class="mb-2">
                      <strong>Application ID: </strong> <span class="text-primary">{{ applicationId }}</span>
                    </p>
                    <p class="text-muted mb-0" style="font-size: 13px;">
                      Your Application ID and password have been sent to your 
                      <strong>{{ deliveryMethodText }}</strong>.
                    </p>
                  </div>
                </div>
                <b-button
                  class="registration-button mt-4"
                  @click="resetForm"
                  block
                >
                  <i class="fa fa-sign-in"></i> Go to Log In
                </b-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-else>
      <div class="text-center py-5">
        <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
      </div>
    </div>
  </div>
</template>

<script>
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import { GCE_REGISTER_ROUTE, GET_GCE_DATES} from '../../../const/api'
import { GET, POST } from '../../../utils/Request'

export default {
  name: 'GCEEquivalenceRegistration',
  data() {
    return {
      step: 1,
      loading: false,
      isButtonLoading: false,
      isAcceptingRegistration : true,
      formData: {
        documentType: 'first_option',
        documentNumber: '',
        email: '',
        mobile: '',
        hscType: 'first_option',
        sscType: 'first_option'
      },
      confirmData: {
        email: '',
        mobile: ''
      },
      deliveryMethod: null,
      applicationId: '',
      documentOptions: [
        { value: 'first_option', text: 'Select Any Option' },
        { value: 'Passport', text: 'Passport' },
        { value: 'BirthRegistration', text: 'Birth Registration Number' },
        { value: 'NID', text: 'NID' }
      ],
      hscOptions: [
        { value: 'first_option', text: 'Select HSC/ Higher Secondary Standard type' },
        { value: 'ALV', text: 'A Level' },
        { value: 'GEN', text: 'General Board' }
      ],
      sscOptions: [
        { value: 'first_option', text: 'Select SSC/ Secondary Standard type' },
        { value: 'OLV', text: 'O Level' },
        { value: 'GEN', text: 'General Board' }
      ]
    }
  },
  computed: {
    isConfirmationValid() {
      const emailValid = !this.formData.email || (this.confirmData.email === this.formData.email)
      const mobileValid = !this.formData.mobile || (this.confirmData.mobile === this.formData.mobile)
      return emailValid && mobileValid && this.deliveryMethod
    },
    deliveryMethodText() {
      if (this.deliveryMethod === 'email') return 'email address'
      if (this.deliveryMethod === 'mobile') return 'mobile number'
      return 'email and mobile number'
    }
  },
  async mounted() {

    // GCERegistration
    // GCEPayment
    // GCEApply
    
    const response = await GET(GET_GCE_DATES);
    const regItem = response.data.find(item => item.key === "GCERegistration");
    if (regItem) {
      const isRegistrationOpen = new Date() >= new Date(regItem.startDate) && new Date() <= new Date(regItem.closeDate);
      if(!isRegistrationOpen){
        iziToast.error({message: 'Registration is currently closed.'});
        this.isAcceptingRegistration = false;
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      }
    }
    this.$nextTick(() => {
      this.loading = false
    })
  },
  methods: {
    goToConfirmation() {
      // Validate that at least email or mobile is provided
      if (!this.formData.email && !this.formData.mobile) {
        iziToast.warning({
          title: 'Required',
          message: 'Please provide at least an email address or a mobile number.'
        })
        return
      }

      if (this.formData.sscType === 'GEN' && this.formData.hscType === 'GEN') {
        iziToast.error({
          title: 'Error',
          message: 'For both General board, you need to go to admission.cu.ac.bd and register with necessary information.',
          timeout: 3000, 
        });
        return;
      }
      // Validate document type selection
      if (this.formData.documentType === 'first_option') {
        iziToast.warning({
          title: 'Required',
          message: 'Please select Passport or Birth Registration or NID Number.'
        })
        return
      }

      // Validate HSC and SSC type
      if (this.formData.hscType === 'first_option' || this.formData.sscType === 'first_option') {
        iziToast.warning({
          title: 'Required',
          message: 'Please select both HSC and SSC types.'
        })
        return
      }

      if (this.formData.mobile.length>0 && (this.formData.mobile.length < 11 || this.formData.mobile.length > 11)) {
          // raise izzytoast error
          iziToast.warning({
            title: 'Error',
            message: 'Please enter a valid mobile number with 11 digits.'
          })
          return
        }
        // raise error if the mobile number starts with +88
        if (this.formData.mobile.startsWith('+88')) {
          iziToast.warning({
            title: 'Error',
            message: 'Please do not include +88 in the mobile number.'
          })
          return
        }


      this.step = 2
    },

    async submitRegistration() {
      this.isButtonLoading = true;

      try {
        // If mobile is empty, set default +88 or less than 11 digits or greater than 11 digits and if it starts with +88
        
        // Make API call
        const response = await POST(GCE_REGISTER_ROUTE, {formData: this.formData, deliveryMethod: this.deliveryMethod});

        // console.log(response)

        // Check response
        if (response.status === 200) {
          const { status, message, application_id } = response.data

          if (status === true) {
            this.applicationId = application_id ? application_id : ''
            iziToast.success({ message: message })
            this.step = 3
          } else {
            iziToast.error({ message: message })
          }
        } else {
          iziToast.error({ message: 'Something went wrong. Please try again.' });
        }
      } catch (error) {
        iziToast.error({
          title: 'Error',
          message: (response && response.data && response.data.msg) 
            ? response.data.msg 
            : 'Registration failed. Please try again.'

        });
      } finally {
        this.isButtonLoading = false;
      }
    },


    goBackToStep1() {
      this.step = 1
      this.confirmData = {
        email: '',
        mobile: ''
      }
      this.deliveryMethod = null
    },

    resetForm() {
      this.formData = {
        documentType: 'first_option',
        documentNumber: '',
        email: '',
        mobile: '',
        hscType: 'first_option',
        sscType: 'first_option'
      }
      this.confirmData = {
        email: '',
        mobile: ''
      }
      this.deliveryMethod = null
      this.applicationId = ''
      window.location.href = '/gce/login'
    }
  },
}
</script>

<style scoped>
.modern-registration-wrapper {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  padding: 20px 0;
  min-height: 100vh;
}

.registration-page {
  width: 100%;
}

.registration-wrapper {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Registration Card */
.registration-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 650px;
  width: 100%;
  margin: auto;
  overflow: hidden;
}

/* Registration Header */
.registration-header {
  text-align: center;
  padding: 50px 30px;
  background: #4e73a8;
}

.logo-img {
  max-width: 90px;
  height: auto;
}

/* Step Indicator */
.step-indicator-wrapper {
  background: #f8fafc;
  padding: 25px 30px;
  border-bottom: 1px solid #e2e8f0;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  margin: 0 auto;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.step.active .step-number {
  background: #2c5aa0;
  color: white;
}

.step.completed .step-number {
  background: #10b981;
  color: white;
}

.step-label {
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.step.active .step-label {
  color: #2c5aa0;
  font-weight: 600;
}

.step-line {
  flex: 1;
  height: 2px;
  background: #e2e8f0;
  margin: 0 8px;
  transition: all 0.3s ease;
  position: relative;
  top: -13px;
  min-width: 30px;
}

.step-line.active {
  background: #2c5aa0;
}

/* Registration Form */
.registration-form {
  padding: 32px 40px 36px;
}

/* Form Group */
.form-group-modern {
  margin-bottom: 18px;
}

.input-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}

/* Input Wrapper */
.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 15px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 11px 14px 11px 40px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fafbfc;
  height: auto;
}

.modern-input:focus {
  outline: none;
  border-color: #2c5aa0;
  background: white;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.08);
}

.modern-input::placeholder {
  color: #a0aec0;
  font-size: 13px;
}

.modern-select {
  width: 100%;
  padding: 11px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fafbfc;
  height: auto;
}

.modern-select:focus {
  outline: none;
  border-color: #2c5aa0;
  background: white;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.08);
}

/* Delivery Options */
.delivery-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.delivery-radio-wrapper {
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: #fafbfc;
  width: 100%;
}

.delivery-radio-wrapper:hover {
  border-color: #2c5aa0;
  background: white;
  width: 100%;
}

.delivery-radio {
  margin: 0;
  width: 100%;
}
.radio-content {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #4a5568;
  height: 100%;
}

.radio-content i {
  font-size: 16px;
  color: #64748b;
}

/* Registration Button */
.registration-button {
  width: 100%;
  padding: 11px 20px;
  background: #2c5aa0;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(44, 90, 160, 0.25);
}

.registration-button:hover:not(:disabled) {
  background: #1e4080;
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.35);
}

.registration-button:active {
  transform: translateY(1px);
}

.registration-button:disabled {
  background: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.registration-button.loading {
  background: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.registration-button.loading:hover {
  background: #94a3b8;
}

.registration-button i {
  margin-right: 6px;
  font-size: 13px;
}

/* Back Button */
.registration-back-button {
  border: 1.5px solid #e2e8f0;
  color: #64748b;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  background: white;
}

.registration-back-button:hover:not(:disabled) {
  border-color: #2c5aa0;
  color: #2c5aa0;
  background: #f8fafc;
}

/* Success Screen */
.success-icon {
  font-size: 64px;
  color: #10b981;
  animation: scaleIn 0.5s ease;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.registration-message {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.credential-info {
  background: white;
  padding: 14px;
  border-radius: 6px;
  margin-top: 14px;
}

/* Smooth animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.registration-card {
  animation: fadeIn 0.4s ease;
}

/* Responsive Design */
@media (max-width: 768px) {
  .step-indicator-wrapper {
    padding: 20px 15px;
  }

  .step-label {
    font-size: 10px;
  }

  .step-number {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .step-line {
    margin: 0 5px;
    min-width: 20px;
  }
}

@media (max-width: 576px) {
  .registration-card {
    max-width: 100%;
    border-radius: 12px;
    margin: 0 15px;
  }

  .registration-header {
    padding: 35px 20px;
  }

  .logo-img {
    max-width: 70px;
  }

  .registration-form {
    padding: 26px 28px 30px;
  }

  .form-group-modern {
    margin-bottom: 16px;
  }

  .modern-input {
    padding: 10px 12px 10px 38px;
    font-size: 13px;
  }

  .input-icon {
    left: 12px;
    font-size: 14px;
  }

  .registration-button {
    padding: 10px 18px;
    font-size: 13px;
  }

  .step-indicator-wrapper {
    padding: 18px 15px;
  }
}
</style>